// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1f8Ft","label":"styles_label__152-N"};